import { makeStyles } from '@fluentui/react-components';

export const chartSizes = {
    width: {
        min: 300,
        max: 400,
    },
    height: 300,
};

export const useChartStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '4px',
        maxWidth: '100%',
    },
    chartContainer: {
        flex: '1 1 auto',
        height: `${chartSizes.height}px`,
        minWidth: `${chartSizes.width.min - 1}px`,
        maxWidth: `${chartSizes.width.max}`,

        '@media (max-width:500px)': {
            display: 'none',
        },
    },
    chartTable: {
        flex: '1 1 auto',
    },
    hidden: {
        display: 'none',
    },
});
